import * as types from './mutation-types'

export const campuses = ({ commit }, payload) => {
    commit(types.LISTS_CAMPUSES, payload)
}

export const utilities = ({ commit }, payload) => {
    commit(types.LISTS_UTILITIES, payload)
}

export const transits = ({ commit }, payload) => {
    commit(types.LISTS_TRANSITS, payload)
}

export const reset = ({ commit }, objName) => {
    commit(types.LISTS_RESET, objName)
}

export default {
    campuses, utilities, transits, reset
}
